import {AbstractControl, UntypedFormGroup} from '@angular/forms';
import {myParseFloat} from '../../../create/properties/utility/float-parser';
import {Sensor} from '../../../model/sensor.model';

export class UpdateSensorFormController {

  constructor(
    private updateSensorForm: UntypedFormGroup
  ) {
  }

  public get instrumentTypeControl(): AbstractControl {
    return this.updateSensorForm.get('instrumentType');
  }

  public get instrumentType(): string {
    return this.instrumentTypeControl.value;
  }

  public get locationNameControl(): AbstractControl {
    return this.updateSensorForm.get('locationName');
  }

  public get locationName(): string {
    return this.locationNameControl.value;
  }

  public get startDateControl(): AbstractControl {
    return this.updateSensorForm.get('startDate');
  }

  public get startDate(): Date {
    if (
      this.startDateControl.value !== undefined &&
      this.startDateControl.value !== null &&
      this.startDateControl.value !== '' &&
      !(this.startDateControl.value instanceof Date)
    ) {
      return new Date(this.startDateControl.value);
    }

    return this.startDateControl.value;
  }

  public get startDateISOString(): string {
    return this.startDate ? this.startDate.toISOString() : '';
  }

  public get endDateControl(): AbstractControl {
    return this.updateSensorForm.get('endDate');
  }

  public get endDate(): Date {
    if (
      this.endDateControl.value !== undefined &&
      this.endDateControl.value !== null &&
      this.endDateControl.value !== '' &&
      !(this.endDateControl.value instanceof Date)
    ) {
      return new Date(this.endDateControl.value);
    }

    return this.endDateControl.value;
  }

  public get endDateISOString(): string {
    return this.endDate ? this.endDate.toISOString() : '';
  }

  public get xcoordinateControl(): AbstractControl {
    return this.updateSensorForm.get('xcoordinate');
  }

  public get xcoordinate(): number {
    return myParseFloat(this.xcoordinateControl.value);
  }

  public get ycoordinateControl(): AbstractControl {
    return this.updateSensorForm.get('ycoordinate');
  }

  public get ycoordinate(): number {
    return myParseFloat(this.ycoordinateControl.value);
  }

  public get zcoordinateControl(): AbstractControl {
    return this.updateSensorForm.get('zcoordinate');
  }

  public get zcoordinate(): number {
    return myParseFloat(this.zcoordinateControl.value);
  }

  public resetUpdateSensorForm(sensor: Sensor) {
    this.instrumentTypeControl.setValue(sensor.instrumentType);
    this.locationNameControl.setValue(sensor.locationName);
    this.startDateControl.setValue(this.toInputDate(sensor.startDate));
    this.endDateControl.setValue(this.toInputDate(sensor.endDate));
    this.xcoordinateControl.setValue(sensor.x);
    this.ycoordinateControl.setValue(sensor.y);
    this.zcoordinateControl.setValue(sensor.z);
  }

  private toInputDate(date: Date | string): string {
    if (date === undefined || date === null) {
      return '';
    }

    return new Date(date).toISOString().split('T')[0];
  }
}
